import React from 'react'
import PropTypes from 'prop-types';
import {withRouter} from "react-router";
import {makeStyles} from "@material-ui/core";
import DocumentsTables from "components/complex/documentsTables/DocumentsTables";
import Section from "../components/Section";
import Tr from "translations/Translations";

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
        position: "relative"
    },
    marginBottom: {
        marginBottom: theme.spacing(2),
    }
}));

function DocumentsSection(
    {
        match,
        siwzEditable,
        repoEditable
    }) {

    const classes = useStyles();
    let demandId = match.params.id;

    return (
        <div id="documentsSection" className={classes.root}>
            <Section
                title={Tr('documents')}
            >
                <DocumentsTables
                    demandId={demandId}
                    repoEditable={repoEditable}
                    siwzEditable={siwzEditable}
                />
            </Section>
        </div>
    )
}


DocumentsSection.propTypes = {
    classes: PropTypes.any,
}

export default withRouter(DocumentsSection);